import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListSortableItemModule } from '../list-sortable-item/list-sortable-item.module';
import { ListSortableComponent, ListSortableComponentAction } from './list-sortable.component';

@NgModule({
  exports: [ListSortableComponent],
  imports: [ListSortableItemModule, CommonModule, DragDropModule, ListSortableComponent],
})
export class ListSortableModule {}

export { ListSortableComponent } from './list-sortable.component';
export { ListSortableComponentAction };
